import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';


import AddStockOperationModel from "../qualityStockfollowups/AddStockOperationModel";

import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';

import {  Apitoken, Authtoken } from '../Global';
// import $ from "jquery";
const QualityStockFollowUpViewByConsumableLocation = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [datain, setDatain] = useState([]);
  const [dataout, setDataout] = useState([]);
  
    const [showmodel, setshowmodel] = useState(false);
    const [stocksgroupby, setStocksgroupby] = useState({});
    const [permission, setPermission] = useState({});
    let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(455)); 
      console.log(permission);

      axios
      .get(`/quality-stock-follow-ups/listing-groupby-comsumble-location-detail/${id+'_'+season_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setDatain(response.data.data.stocks_in);
        setDataout(response.data.data.stocks_out);
        //setManualinqty(response.data.data.manually_quatity.in);
        //setManualoutqty(response.data.data.manually_quatity.out);
        setStocksgroupby(response.data.data.stocks_groupby[0]);
        //setPalletquantityout(response.data.data.product_out_final);
    
        
        //setConsumble(response.data.data.consumable_detail);
       

      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const addForm = () => {
    console.log('add');
    setshowmodel(true);
  };

  const handleClose = () => {
    setshowmodel(false);
    //setshowmodelEdit(false);
    //setSelectedItemId(null);
  };
  
  // 🔹 Separate Cell Component for "Delivery Note"
const DeliveryNoteCell = ({ row }) => {
  if (row.original?.delivery_note) {
    return (
      <a
        className="btn btn-primary"
        href={viewFile(row.original.delivery_note)} // Ensure viewFile is defined
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        Download
      </a>
    );
  }
  return null; // Return nothing if delivery_note is null
};

// ✅ Define PropTypes
DeliveryNoteCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      delivery_note: PropTypes.string, // Ensure delivery_note is a string
    }),
  }).isRequired,
};

// 🔹 Column Configuration
const columns = [
  {
    accessorKey: 'location_name',
    header: 'Location',
  },
  {
    accessorKey: 'date',
    header: 'Date',
  },
  {
    accessorKey: 'operation',
    header: 'Operation',
  },
  {
    accessorKey: 'delivery_note_number',
    header: 'Delivery Note Number',
  },

  {
    header: 'Consumable',
    accessorFn: (row) =>
      row.consumable_product ? row.consumable_product.consumable_name : '',
  },
  {
    accessorKey: 'quantity',
    header: 'Quantity',
  },

  {
    accessorKey: 'note',
    header: 'Note',
  },
  {
    accessorKey: 'created_at',
    header: 'Created',
  },
  {
    header: 'Delivery Note',
    Cell: DeliveryNoteCell, // ✅ Use separate component
  },
   {
         header: "Created By",
         accessorFn: (row) =>
           `${row.createdby ? row.createdby.first_name + " " + row.createdby.last_name : ""}`,
    },
  {
         header: "Updated By",
         accessorFn: (row) =>
           `${row.updatedby ? row.updatedby.first_name + " " + row.updatedby.last_name : ""}`,
    },
 
];
   const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

 
  const editItem = (item)=>{
    window.location.href = "/quality-stock-situations-edit/"+item;
  }
  

  // const deleteItemManual = (item) => {

  //   Swal.fire({
  //     title: 'Do you really want to delete this record?',
  //     //text: 'This action cannot be undone.',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'DELETE'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios.get(`/quality-stock-follow-ups/delete-manual/${season_id+'-'+item}`, {
  //             headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //           })
  //           .then((response) => {
  //             console.log(response);
  //             if (response.data.code === 200) {
  //               Swal.fire(
  //                 'Deleted!',
  //                 'Your Record has been deleted.',
  //                 'success'
  //               );
  //               setTimeout(() => {
  //                 window.location.href = "/quality-stock-situations-viewby-consumable-location/"+id;
  //               }, 500);
  //             }
  //           })
  //           .catch((error) => {
  //             console.log(error);
  //           }); 
  //          }
  //   });
  // }

  // const deleteItem = (item) => {

  //   Swal.fire({
  //     title: 'Do you really want to delete this record?',
  //     //text: 'This action cannot be undone.',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'DELETE'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios.get(`/quality-stock-follow-ups-qty/delete/${season_id+'-'+item}`, {
  //             headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //           })
  //           .then((response) => {
  //             console.log(response);
  //             if (response.data.code === 200) {
  //               Swal.fire(
  //                 'Deleted!',
  //                 'Your Record has been deleted.',
  //                 'success'
  //               );
  //               setTimeout(() => {
  //                 window.location.href = "/quality-stock-situations-viewby-consumable-location/"+id;
  //               }, 500);
  //             }
  //           })
  //           .catch((error) => {
  //             console.log(error);
  //           }); 
  //          }
  //   });
  // }

  console.log(stocksgroupby);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

 

  const deleteItem = (item) => {
    let season_id = localStorage.getItem("season_id");

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/quality-stock-follow-ups/delete2/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                 axios
                  .get(`/quality-stock-follow-ups/listing-groupby-comsumble-location-detail/${id+'_'+season_id}`, {
                    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                  })
                  .then((response) => {
                    setDatain(response.data.data.stocks_in);
                    setDataout(response.data.data.stocks_out);
                     setStocksgroupby(response.data.data.stocks_groupby[0]);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                // setTimeout(() => {
                //   window.location.href = "/quality-stock-situations-viewby-consumable-location/"+id;
                // }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Quality Stock Situations Group By Consumable and Location </h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/profile">Profile</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/quality-stock-situations">Quality Stock Situations</Link>
                      </li>
                      <li className="breadcrumb-item active">Quality Stock Situations Group By Consumable and Location</li>
                    </ul>
                </div>
                <div className="">
              <button  onClick={() => addForm()} className="btn btn-primary" style={{float:"right"}}>
                    <i className="fas fa-plus"></i>
                  </button>
          
              </div>
              </div>
            </div>
            <div className="row">
            <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity IN</div>
                          <div className="dash-counts">
                          <p>   {(parseFloat(stocksgroupby.total_in_quantity)).toFixed(2)}
                          </p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity OUT</div>
                          <div className="dash-counts">
                            <p>{(parseFloat(stocksgroupby.total_out_quantity || 0)).toFixed(2)}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity Available </div>
                          <div className="dash-counts">
                          <p>
                            {
                              (
                                (parseFloat(stocksgroupby.total_in_quantity || 0))  - (parseFloat(stocksgroupby.total_out_quantity || 0))
                              ).toFixed(2)
                              
                            }
                          </p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                      
                </div>

          
            </div>


            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                  <table className="table table-bordered">
                    <tr>
                   
                      <th  className="p-3">Consumble </th>
                      <td className="p-3">  {stocksgroupby.consumable_product ? stocksgroupby.consumable_product.consumable_name : ""}</td>
                    </tr>
                    <tr> <th className="p-3">Location </th>
                      <td className="p-3">
                        {stocksgroupby.location_name ? stocksgroupby.location_name : ""}
                      </td>
                    </tr>
                    
                
                  </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">

<div className="card-body">
                      <ul className="nav nav-tabs nav-tabs-bottom">
                      

                      <li className="nav-item">
                          <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">IN</a>                                  
                      </li>
                      <li className="nav-item">
                          <a className="nav-link " href="#listing-customer" data-bs-toggle="tab"> OUT</a>                                   
                      </li> 
                                      
                      </ul>
                      <div className="tab-content">

                      <div className="tab-pane show active" id="listing-groupby-supplier">
                      <div className="row"   id="listing-followup">
                        <div className="col-sm-12">
                          <div className="card card-table">
                            <div className="card-body">
                                <div className="table-responsive">

                                <MaterialReactTable columns={columns} data={datain} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                            //renderColumnActionsMenuItems 
                                            renderRowActionMenuItems={({ row }) => [
                                                                                                                        
                                                permission?.update == 1 && (
                                                  <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                                    Edit
                                                  </MenuItem>
                                                ),
                                                permission?.delete == 1 && (
                                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                    Delete
                                                  </MenuItem>
                                                ),
                                              ]}

                                            // renderRowActionMenuItems={({ row }) => {
                                            //   //console.log('Row:', row.original); // ← Add this
                                            
                                            //   const actions = [];
                                            //   const addType = row.original.add_type?.trim().toLowerCase();
                                            //   //console.log('Normalized add_type:', addType); // ← And this
                                            
                                            //   if (addType === 'manual') {
                                            //     actions.push(
                                            //       <MenuItem key="delete-manual" onClick={() => deleteItemManual(row.original.id)}>
                                            //         Delete
                                            //       </MenuItem>
                                            //     );
                                            //   } else {
                                            //     actions.push(
                                            //       <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                            //         Edit
                                            //       </MenuItem>,
                                            //       // <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                            //       //   Delete
                                            //       // </MenuItem>
                                            //     );
                                            //   }
                                            
                                            //   return actions;
                                            // }}
                                          />
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        
                        </div>                                
                        <div className="tab-pane  " id="listing-customer">
                              <div className="row"   id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                        <MaterialReactTable columns={columns} data={dataout} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                           
                                             renderRowActionMenuItems={({ row }) => [
                                                                                                                        
                                                permission?.update == 1 && (
                                                  <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                                    Edit
                                                  </MenuItem>
                                                ),
                                                permission?.delete == 1 && (
                                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                    Delete
                                                  </MenuItem>
                                                ),
                                              ]}

                                            // renderRowActionMenuItems={({ row }) => {
                                            //   //console.log('Row:', row.original); // ← Add this
                                            
                                            //   const actions = [];
                                            //   const addType = row.original.add_type?.trim().toLowerCase();
                                            //   //console.log('Normalized add_type:', addType); // ← And this
                                            
                                            //   if (addType === 'manual') {
                                            //     actions.push(
                                            //       <MenuItem key="delete-manual" onClick={() => deleteItemManual(row.original.id)}>
                                            //         Delete
                                            //       </MenuItem>
                                            //     );
                                            //   } else {
                                            //     actions.push(
                                            //       <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                            //         Edit
                                            //       </MenuItem>,
                                            //       // <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                            //       //   Delete
                                            //       // </MenuItem>
                                            //     );
                                            //   }
                                            
                                            //   return actions;
                                            // }}
                                          />
                                        
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        
                        </div>                                
                                          
                         
                      </div>                             
                    </div>

                      
                  </div>
                </div>
              </div>
            </div>


                    <AddStockOperationModel show={showmodel} handleClose={handleClose} />
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityStockFollowUpViewByConsumableLocation;
